import {Linear, TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpacierArcadeGameAssets} from "../../SpacierArcadeGameAssets";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SpacierArcadeParsedGameData} from "../../server/data/SpacierArcadeParsedGameData";
import {StandardAutoCloseGameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeSoundConfig} from "../../SpacierArcadeSoundConfig";
import {SpacierArcadeGameModuleConfig} from "../../SpacierArcadeGameModuleConfig";

export class AAFreespinOutroView extends StandardAutoCloseGameModeTransitionView {
    private _scatterTriggerSpine:PIXI.spine.Spine;
    private _innerGraphicsContainer:PIXI.Container;
    private _innerGraphicsZeroWinContainer:PIXI.Container;
    private _restSymbolCallback:() => void;
    private _winAmonut:BitmapCountUp;
    private _totalWin:number;
    private _totalSpinsPlayed:number;
    private _spinsPlayedText:PIXI.Text;
    private _totalWinText: PIXI.Text;

    private _tempStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 50,
        fontWeight : FontWeight.BOLD,
        align : "center",
        dropShadow : true,
        dropShadowAlpha : 0.6,
        dropShadowAngle : 89.5,
        dropShadowBlur : 6,
        dropShadowColor : "#1a1740",
        dropShadowDistance : 3,
        fill : [
            "#fff7e8",
            "#fffdec",
            "#fff0aa",
            "#ffc733"
        ],
        miterLimit : 7,
        stroke : "#bd1e96",
        strokeThickness : 1
    };
    private _restrictWinSound:boolean;

    constructor(layer:ScalableLayer, autoCloseTimerDuration:number = 2000000) {
        super(layer, autoCloseTimerDuration);
    }


    protected createBackground(): PIXI.DisplayObject {
        return new PIXI.Container();
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container: PIXI.Container = new PIXI.Container();
        this._scatterTriggerSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.FG_EFFECTS));
        // this._scatterTriggerSpine.piv
        this._scatterTriggerSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.49 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.5 +  GameConfig.instance.REEL_AREA_POS_Y);
        this._scatterTriggerSpine.autoUpdate = true;
        container.addChild(this._scatterTriggerSpine);


        this._innerGraphicsContainer = new PIXI.Container();
        this._innerGraphicsZeroWinContainer = new PIXI.Container();

        let fixedZeroText:PIXI.Text = new PIXI.Text(Translation.translate("SPINS PLAYED"), this._tempStyle);
        fixedZeroText.anchor.set(0.5);
        fixedZeroText.position.set(5, -140);

        this._spinsPlayedText = new PIXI.Text(Translation.translate("0"), this._tempStyle);
        this._spinsPlayedText.anchor.set(0.5);
        this._spinsPlayedText.position.set(10, -20);

        this._innerGraphicsZeroWinContainer.addChild(fixedZeroText);
        this._innerGraphicsZeroWinContainer.addChild(this._spinsPlayedText);
        this._innerGraphicsZeroWinContainer.visible = false;
        container.addChild(this._innerGraphicsZeroWinContainer);

        let fixedText:PIXI.Text = new PIXI.Text(Translation.translate("TOTAL WIN"), this._tempStyle);
        fixedText.anchor.set(0.5);
        fixedText.position.set(5, -100);
        this._totalWinText = fixedText;

        this._winAmonut = new BitmapCountUp(
            {
                style : {
                    font : {name : "mw_font", size : 12},
                    tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
                }
            });

        this._winAmonut.shrinkSize = true;
        this._winAmonut.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._winAmonut.position.set(0, 20);
        this._innerGraphicsContainer.addChild(this._winAmonut);
        this._innerGraphicsContainer.addChild(fixedText);
        this._innerGraphicsContainer.visible = false;
        container.addChild(this._innerGraphicsContainer);
        return container;
    }

    public playScatterTrigger():TimelineLite{
        let animTimeLine:TimelineLite = new TimelineLite( {onComplete: () => {
                this._scatterTriggerSpine.state.setAnimationByName(0, "fs_outro_idle", true);
            }});
        animTimeLine.add([
            new SpineTween(this._scatterTriggerSpine, 0, "fs_outro"),
            () => {
                if (!this._restrictWinSound) {
                    SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_ENDS_SWEEP);
                }
            }
        ]);
        return animTimeLine;
    }


    public playEndingAnimation():TimelineLite{
        let animTimeLine:TimelineLite = new TimelineLite( {onComplete: () => {
                this._scatterTriggerSpine.skeleton.setToSetupPose();
                this._scatterTriggerSpine.state.tracks = [];
                this._scatterTriggerSpine.state.setEmptyAnimation(0, 0);
            }});
        animTimeLine.add(new SpineTween(this._scatterTriggerSpine, 0, "fs_outro_continue_click"));
        return animTimeLine;
    }


    protected onResize(resizeData: IResizeData): void {
        super.onResize(resizeData);
        let ispotrait:boolean = resizeData.orientation === Orientation.PORTRAIT;
        this.resizeSAButton(ispotrait);
        if(ispotrait){
            this._scatterTriggerSpine.position.set(GameConfig.instance.GAME_WIDTH * 0.27, GameConfig.instance.REEL_AREA_HEIGHT * 0.71);
            this._innerGraphicsContainer.position.set(GameConfig.instance.GAME_WIDTH * 0.27, GameConfig.instance.REEL_AREA_HEIGHT * 0.71);
            this._innerGraphicsZeroWinContainer.position.set(GameConfig.instance.GAME_WIDTH * 0.27, GameConfig.instance.REEL_AREA_HEIGHT * 0.71);
        }
        else{
            this._scatterTriggerSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.53);
            this._innerGraphicsContainer.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + 7, GameConfig.instance.REEL_AREA_HEIGHT * 0.6);
            this._innerGraphicsZeroWinContainer.position.set(GameConfig.instance.GAME_WIDTH * 0.29, GameConfig.instance.REEL_AREA_HEIGHT * 0.71);
        }
        // this._innerGraphicsContainer.scale.set(this._orientationScale);
        // this._scatterTriggerSpine.scale.set(this._orientationScale);
    }

    private resizeSAButton(ispotrait:boolean):void {
        const buttonSize:PIXI.Point = new PIXI.Point(this.BUTTON_SIZE.x * this._deviceScale, this.BUTTON_SIZE.y * this._deviceScale);
        this._button.setSize(buttonSize.x, buttonSize.y, this._layer.scale.x);
        this._button.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.51, ispotrait? GameConfig.instance.REEL_AREA_HEIGHT: GameConfig.instance.REEL_AREA_HEIGHT * 0.85);
    }

    public prepare(data:SpacierArcadeParsedGameData):void {
        this._totalWin = data.totalWin;
        this._totalSpinsPlayed = data.numberOfFreespinsPlayed || 0;

        this._restrictWinSound = SpacierArcadeGameModuleConfig.featurePrice.isWinBelowStake();
    }

    public getStartAnimation(prepareToEnterModeCallback:() => void, completeCallback:() => void):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._button.visible = false;
            this._autoCloseTimer.visible = false;
            this._innerGraphicsZeroWinContainer.visible = false;
            this._innerGraphicsContainer.visible = false;
            this._scatterTriggerSpine.skeleton.setToSetupPose();
            this._scatterTriggerSpine.state.tracks = [];
            this._scatterTriggerSpine.state.setEmptyAnimation(0, 0);
            this._layer.addChild(this);

            this._totalWinText.visible = !this._restrictWinSound;
        });

        tl.add([
            new TweenLite(this._mainGraphicsContainer, 0.5, {alpha : 1, ease : Linear.easeNone})
        ]);
        tl.add(() => {
            prepareToEnterModeCallback();
        });
        tl.add(this.playScatterTrigger());
        if(this._totalWin > 0) {
            tl.add([
                () => {
                    this._innerGraphicsContainer.visible = true;
                    TweenLite.fromTo(this._winAmonut, 0.55,
                        {alpha: 0},
                        {alpha: 1, onStart: () => {
                            if (!this._restrictWinSound){
                                SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_ENDS);
                            }
                            this._winAmonut.visible = true;
                        }});
                    this._button.visible = true;
                    this._autoCloseTimer.visible = false;
                    this.startTimerAndEnableButton(completeCallback);

                },
                this._winAmonut.getCountUpAnimation(this._totalWin, this._totalWin, {duration: 0})
            ], tl.totalDuration() / 2.4);
        }else{
            tl.add([
                () => {
                    if (!this._restrictWinSound){
                        SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_ENDS);
                    }
                    this._spinsPlayedText.text = this._totalSpinsPlayed.toString();
                    this._innerGraphicsZeroWinContainer.visible = true;
                    this._button.visible = true;
                    this._autoCloseTimer.visible = false;
                    this.startTimerAndEnableButton(completeCallback);
                }
            ], tl.totalDuration() / 2.4);
        }
        tl.add(() => {
            SlotGame.sound.playAmbience(SpacierArcadeSoundConfig.instance.MAIN_GAME_AMBIANCE)
        }, tl.totalDuration() / 2.4 + 0.183);

        return tl;
    }

    public getEndAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_OUTRO_CONTINUE);
            SlotGame.sound.playAmbience(SpacierArcadeSoundConfig.instance.MAIN_GAME_AMBIANCE);
        });
        tl.add([
            new TweenLite(this._mainGraphicsContainer, 0.5, {alpha : 0, ease : Linear.easeNone}),
        ]);
        tl.add(() => {
            this._scatterTriggerSpine.skeleton.setToSetupPose();
            this._scatterTriggerSpine.state.tracks = [];
            this._scatterTriggerSpine.state.setEmptyAnimation(0, 0);
            this._layer.removeChild(this);

            SpacierArcadeGameModuleConfig.featurePrice.reset();
        });
        return tl;
    }

    public getRestSymbolCallback(restSymbolCallback:() => void):void {
        this._restSymbolCallback = restSymbolCallback;
    }

    private resetSymbols():void {
        if(this._restSymbolCallback) {
            this._restSymbolCallback();
        }
    }
}